export const privacyContent = `
<div class="space-y-8">
  <!-- 1. 私たちは何者ですか -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">私たちは何者ですか</h2>
    <p class="text-gray-300 leading-relaxed">
      私たちは <strong>OXO Play</strong>（以下、「<em>OXO Play</em>」、「<em>当社</em>」、「<em>私たち</em>」といいます）です。さまざまなウェブゲームを便利に楽しめるオンラインゲームプラットフォーム（以下、「<em>プラットフォーム</em>」）を提供しております。アカウント（以下、「<em>アカウント</em>」）を登録して利用することも、登録せずに利用することも可能です。プラットフォームは地域によって異なる公式ウェブサイト（以下、「<em>ウェブサイト</em>」）を通じてアクセスできます。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      当社は、お客様の信頼を大切にし、プライバシー保護を真剣に考えています。本プライバシーポリシー（以下、「<em>本ポリシー</em>」）では、プラットフォームのご利用時に当社がお客様の個人データをどのように収集・処理・開示・保持・保護するかを説明しています。お客様の権利と当社の責任を理解していただくために、よくお読みください。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      プラットフォームは、原則として13歳以上（またはお客様の居住国が定める最低年齢以上）を対象としています。もし13歳未満（または居住国の適用最低年齢未満）の場合は、プラットフォームをご利用いただけません。また、当社は意図的にそれ以下の年齢の方から個人情報を収集することはありません。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      当社の利用規約（Terms of Service）につきましては、別途ご確認ください。
    </p>
  </section>

  <!-- 2. 個人データとは何ですか -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">個人データとは何ですか</h2>
    <p class="text-gray-300 leading-relaxed">
      「<strong>個人データ</strong>」とは、お客様を直接的または間接的に特定できる情報を指します。たとえば、氏名やメールアドレスが含まれます。お客様のアカウントと関連付けられる場合は、プレイしたゲームの履歴なども個人データに含まれます。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      特にマルチプレイヤーゲーム等では、実名や個人情報の共有はなるべく控えていただくことを推奨いたします。
    </p>
  </section>

  <!-- 3. 当社は誰から個人データを収集しますか -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">当社は誰から個人データを収集しますか</h2>
    <p class="text-gray-300 leading-relaxed">
      プラットフォームを運営するため、当社は以下のようなソースからデータを収集する場合があります：
    </p>
    <ul class="list-disc list-inside mt-4 text-gray-300 space-y-2">
      <li>プラットフォームおよびウェブサイトの訪問者やユーザー</li>
      <li>ウェブゲームの開発者</li>
      <li>ご自身の連絡先情報を提供していただいた方</li>
      <li>メールやサポートチケットなどの手段で当社に連絡した方</li>
    </ul>
    <p class="text-gray-300 leading-relaxed mt-4">
      先述のとおり、当社は原則として13歳以上（または居住国の定める最低年齢以上）のユーザーからのみ個人データを収集します。
    </p>
  </section>

  <!-- 4. OXO Playはどのような個人データをどのような目的で処理しますか -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">OXO Playはどのような個人データをどのような目的で処理しますか</h2>
    <p class="text-gray-300 leading-relaxed">
      以下の表に、当社が収集・処理する個人データの種類と目的（「なぜ」）、および法的根拠（「どのような根拠」）をまとめています：
    </p>
    <div class="overflow-auto mt-4">
      <table class="min-w-full text-left text-gray-300 border-collapse">
        <thead>
          <tr>
            <th class="border-b py-2 pr-4 font-semibold">目的</th>
            <th class="border-b py-2 pr-4 font-semibold">収集される個人データ</th>
            <th class="border-b py-2 font-semibold">法的根拠</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              求人応募の審査
            </td>
            <td class="border-b py-2 pr-4 align-top">
              メールアドレス、氏名、年齢、性別、履歴書（CV）
            </td>
            <td class="border-b py-2 align-top">
              契約の履行または契約締結前の措置を講じるために必要
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              アカウントの登録・認証
            </td>
            <td class="border-b py-2 pr-4 align-top">
              メールアドレス、氏名、年齢、性別、外部アカウント情報、ユーザー名、パスワード
            </td>
            <td class="border-b py-2 align-top">
              ご本人の事前かつ明確な同意
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              ゲーム体験のパーソナライズ
            </td>
            <td class="border-b py-2 pr-4 align-top">
              ユーザー名、デバイス/接続情報、選択した興味、ゲームプレイ行動、フィードバック
            </td>
            <td class="border-b py-2 align-top">
              ご本人の事前かつ明確な同意
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              お問い合わせや苦情への対応
            </td>
            <td class="border-b py-2 pr-4 align-top">
              氏名、メールアドレス、その他お客様が提供する情報
            </td>
            <td class="border-b py-2 align-top">
              プラットフォーム品質向上のための正当な利益
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              新機能に関するご案内
            </td>
            <td class="border-b py-2 pr-4 align-top">
              ユーザー名、メールアドレス
            </td>
            <td class="border-b py-2 align-top">
              有益な情報を提供するための正当な利益
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              プラットフォーム改善のための利用統計分析
            </td>
            <td class="border-b py-2 pr-4 align-top">
              ユーザー行動データ（利用・デバイス情報）、ゲーム内統計
            </td>
            <td class="border-b py-2 align-top">
              プラットフォーム性能およびユーザー体験を理解するための正当な利益
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              法的義務の遵守
            </td>
            <td class="border-b py-2 pr-4 align-top">
              適用される法律で要求されるデータ
            </td>
            <td class="border-b py-2 align-top">
              法的義務の履行に必要
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              不正行為・違法行為の防止
            </td>
            <td class="border-b py-2 pr-4 align-top">
              詐欺や違法行為を検出するために必要なデータ
            </td>
            <td class="border-b py-2 align-top">
              不正・違法行為を防止するための正当な利益
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              マーケティングコミュニケーション
            </td>
            <td class="border-b py-2 pr-4 align-top">
              ユーザー名、メールアドレス
            </td>
            <td class="border-b py-2 align-top">
              ご本人の事前かつ明確な同意
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              プラットフォーム上の広告配信
            </td>
            <td class="border-b py-2 pr-4 align-top">
              クッキーなどによるデータ（IPアドレス、ユーザーID、ブラウザタイプなど）
            </td>
            <td class="border-b py-2 align-top">
              プライバシー＆クッキーポリシーおよび広告設定に関する事前かつ明確な同意
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              ゲーム開発者への支払い等の履行
            </td>
            <td class="border-b py-2 pr-4 align-top">
              メールアドレス、税務ID、銀行口座情報、支払い情報
            </td>
            <td class="border-b py-2 align-top">
              契約履行に必要
            </td>
          </tr>
          <tr>
            <td class="border-b py-2 pr-4 align-top">
              ゲーム内購入の実行
            </td>
            <td class="border-b py-2 pr-4 align-top">
              購入に関するデータ（第三者の決済プロバイダによる処理）
            </td>
            <td class="border-b py-2 align-top">
              契約履行に必要
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="text-gray-300 leading-relaxed mt-4">
      <strong>アカウント登録:</strong> アカウントを登録する場合、お客様はパスワード、メールアドレス、ユーザーエージェント、IPアドレスなどを当社に提供することに同意したものとみなされます。当社はFacebookやGoogleなどの第三者サービスを通じたログインをサポートする場合があり、その場合、これら第三者サービスがお客様の氏名やメールアドレス、生年月日などを当社に共有することになります。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      <strong>広告:</strong> 当社はプラットフォーム上で様々な広告主の広告を掲載する場合があります。これにはパーソナライズ広告または非パーソナライズ広告が含まれます。パーソナライズ広告にはお客様の同意が必要であり、IPアドレスや広告IDなどの一部データが第三者の広告ネットワークと共有される可能性があります。クッキー管理ツールまたはブラウザの設定で広告設定を調整できます。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      <strong>プロファイリング:</strong> プレイ中のゲームデータ（ゲーム内統計など）を分析し、お客様に合ったゲームを推奨する場合があります。これは法的に重大な影響を及ぼす自動意思決定には該当しません。EEAや英国など特定地域にお住まいの場合、プロファイリングやダイレクトマーケティングに異議を申し立てる権利を有する場合があります。
    </p>
  </section>

  <!-- 5. 当社はお客様の個人データを他者と共有しますか -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">当社はお客様の個人データを他者と共有しますか</h2>
    <p class="text-gray-300 leading-relaxed">
      当社は以下のような場合に個人データを共有することがあります：
    </p>
    <ul class="list-disc list-inside mt-4 text-gray-300 space-y-2">
      <li>
        <strong>サービスプロバイダ：</strong> ITサービス、決済処理、データ分析などの運営を支援する第三者
      </li>
      <li>
        <strong>他のユーザー：</strong> プロフィールを公開または一部公開に設定した場合（例：ユーザー名、ゲーム戦績など）、他のユーザーがそれらを閲覧できる場合があります。アカウント設定で公開範囲を変更可能です。
      </li>
      <li>
        <strong>広告：</strong> ハッシュ化されたメールアドレス、IPアドレスなど、匿名または仮名化した情報を広告ネットワークと共有し、パーソナライズ広告を配信することがありますが、お客様の同意が必要です。
      </li>
      <li>
        <strong>ゲーム開発者：</strong> プラットフォーム上の一部ゲームは外部のパートナーが開発しています。匿名化した利用統計や、ゲーム内購入に必要な特定のデータを共有する場合があります。
      </li>
      <li>
        <strong>決済プロバイダ：</strong> ゲーム内購入を行う場合、支払いは外部の決済事業者が処理します。当社はお客様の決済明細をアカウントに紐づけますが、支払いの詳細データそのものを直接収集することはありません。
      </li>
      <li>
        <strong>国際データ移転：</strong> お客様のデータが居住国以外へ移転される場合があります。その場合、標準契約条項（Standard Contractual Clauses）など、適切な保護措置を講じます。
      </li>
    </ul>
  </section>

  <!-- 6. お客様の個人データはどのくらい保管されますか -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">お客様の個人データはどのくらい保管されますか</h2>
    <p class="text-gray-300 leading-relaxed">
      当社は本ポリシーに記載された目的を達成するために必要な期間のみ、お客様の個人データを保管します。アカウントをお持ちの場合、ご自身で削除を要請しない限り、法的および事業上必要とされる期間は保管される場合があります。アカウントの削除は元に戻せないため、削除後はアカウントおよび関連する情報にアクセスできなくなります。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      また、法的要件の遵守、紛争処理、詐欺防止等が必要な場合は、より長期間保管する場合があります。
    </p>
  </section>

  <!-- 7. OXO Playはお客様のデータを安全に保護していますか -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">OXO Playはお客様のデータを安全に保護していますか</h2>
    <p class="text-gray-300 leading-relaxed">
      当社は、お客様の個人データが紛失、盗難、不正アクセスなどのリスクから保護されるよう、技術的かつ組織的なセキュリティ対策を実施しています。また、必要な担当者のみがデータにアクセスできるよう制限しています。第三者プロセッサと提携する場合も、厳格なデータ保護基準を守るよう求めています。
    </p>
  </section>

  <!-- 8. お客様にはデータに対するコントロール権があります -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">お客様にはデータに対するコントロール権があります</h2>
    <p class="text-gray-300 leading-relaxed">
      お客様の居住地域の法律により、以下の権利を有する場合があります：
    </p>
    <ul class="list-disc list-inside mt-4 text-gray-300 space-y-2">
      <li><strong>アクセスおよびコピー取得：</strong> 当社が保有するお客様の個人データを確認し、そのコピーを入手する</li>
      <li><strong>訂正：</strong> 不正確または変更があった個人データを訂正する</li>
      <li><strong>削除（忘れられる権利）：</strong> 正当な理由がない限り、個人データの削除を要求する</li>
      <li><strong>処理の制限：</strong> 一定の条件下で、お客様のデータ処理を一時的に制限する</li>
      <li><strong>同意の撤回：</strong> 以前に行った同意をいつでも撤回する</li>
      <li><strong>マーケティング／プロファイリング拒否：</strong> ダイレクトマーケティングやプロファイリングを拒否する</li>
      <li><strong>データポータビリティ：</strong> 構造化された一般的に使用される機械可読形式で自分のデータのコピーを要求する</li>
      <li><strong>差別の禁止：</strong> 上記権利の行使により差別されることはありません</li>
    </ul>
    <p class="text-gray-300 leading-relaxed mt-4">
      これらの権利を行使したい場合は、ウェブサイトで案内している方法（お問い合わせフォーム、メールなど）でご連絡ください。法的義務に従い、合理的な期間内に対応します。必要に応じてご本人確認をお願いする場合があります。
    </p>
  </section>

  <!-- 9. 広告設定の管理 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">広告設定の管理</h2>
    <p class="text-gray-300 leading-relaxed">
      当社ウェブサイトに初めてアクセスするとき、コンセントマネジメントプラットフォーム（CMP）を通じてクッキー設定を受け入れるか拒否するかを選択できます。アカウント設定または「Preferences」リンクからいつでも広告設定を変更できます。ブラウザでクッキーをブロックすることもできますが、その場合、一部の機能が利用できなくなる可能性があります。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      オンライン行動ターゲティング広告や選択肢について詳しくは、関連する広告団体などが提供している情報をご確認ください。
    </p>
  </section>

  <!-- 10. 子どものプライバシー -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">子どものプライバシー</h2>
    <p class="text-gray-300 leading-relaxed">
      当社のプラットフォームは13歳以上（または国が定める最低年齢以上）の方を対象としています。当社は13歳未満のお子様から意図的に個人情報を収集しません。万が一、13歳未満のお子様の情報を収集していることが判明した場合は、速やかに当社へご連絡ください。確認後、速やかに該当情報を削除いたします。
    </p>
  </section>

  <!-- 11. 他のウェブサイトへのリンク -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">他のウェブサイトへのリンク</h2>
    <p class="text-gray-300 leading-relaxed">
      当社のプラットフォームや一部のゲームには、当社が運営していない外部サイトへのリンクが含まれる場合があります。これらの第三者サイトやサービスのプライバシーポリシーについて、当社は責任を負いませんので、ご利用時にそのポリシーをご確認ください。
    </p>
  </section>

  <!-- 12. 外部でホスティングされているゲーム -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">外部でホスティングされているゲーム</h2>
    <p class="text-gray-300 leading-relaxed">
      本ポリシーは、OXO Play以外のデータ管理者やゲーム開発者が運営するゲームには適用されません。当社はこれらの開発者に対して関連法規の遵守を求めていますが、ゲームをプレイする前に各開発者のプライバシーポリシーをご確認されることをお勧めします。
    </p>
  </section>

  <!-- 13. 米国におけるプライバシー権 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">米国におけるプライバシー権</h2>
    <p class="text-gray-300 leading-relaxed">
      一部の米国州法では、お客様の個人情報に関して、アクセス、削除、「販売」または「共有」のオプトアウトなど特定の権利が認められる場合があります。当社は、該当する法律に従い、そのような権利を行使できるよう対応いたします。
    </p>
    <p class="text-gray-300 leading-relaxed mt-4">
      当社は、お客様がこれらの権利を行使したことによって、お客様を差別することはありません。
    </p>
  </section>

  <!-- 14. 本プライバシーポリシーの変更 -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">本プライバシーポリシーの変更</h2>
    <p class="text-gray-300 leading-relaxed">
      当社は随時、本ポリシーを更新し、ドキュメント上部に「最終更新日」を表示します。重大な変更がある場合は、プラットフォーム上でのお知らせやメールなどを通じて通知する場合があります。改訂後もプラットフォームの利用を継続された場合、改訂内容に同意したものとみなします。
    </p>
  </section>

  <!-- 15. データに関するご質問はありますか -->
  <section>
    <h2 class="text-2xl font-semibold mb-4">データに関するご質問はありますか</h2>
    <p class="text-gray-300 leading-relaxed">
      本プライバシーポリシーまたは当社のデータ取扱いについてご不明点がある場合は、 
      <a href="/contact" class="underline hover:no-underline">Contact Us</a>
      ページまたは記載のメールアドレスをご利用ください。ご質問や懸念点を十分に解決できない場合、お住まいの地域のデータ保護当局に苦情を申し立てる権利があります。
    </p>
  </section>
</div>
`; 